import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../../images/goToBack.svg";

const GoToBackWhiteIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default GoToBackWhiteIcon;
